  
document.addEventListener('DOMContentLoaded', function () {
    if (document.querySelectorAll('body.index').length > 0) {
        const heading = document.querySelector('#heading_pd h1');
        const subtext = document.getElementById('text_pd');
        const button = document.querySelector('.banner_animateBtn');
        const lines = heading.innerHTML.split('<br>');
        const text = heading.textContent;
        heading.innerHTML = '';
    
        let totalDelay = 0;
        lines.forEach((line, lineIndex) => {
            const characters = line.split('');
    
            characters.forEach((char, charIndex) => {
                const span = document.createElement('span');
                span.textContent = char;
                if (char === ' ') {
                    span.className = 'space';
                } else {
                    span.className = 'letter';
                }
    
                span.style.animationDelay = `${totalDelay * 0.08}s`;
                heading.appendChild(span);
                totalDelay++;
            });
            if (lineIndex !== lines.length - 1) {
                heading.appendChild(document.createElement('br'));
            }
        });
        // const delayTime = text.length * 80 + 500;
        // setTimeout(() => {
        //     subtext.style.opacity = 1;
        // }, delayTime);
        // setTimeout(() => {
        //     button.style.opacity = 1;
        // }, delayTime + 1000);
    }
    
    class AnimatedHeroImage {
        constructor(section) {
        const isInFooter = section.closest('.shopify-section-group-footer-group');
        if (isInFooter) return;

          this.section = section;
          const media = section; 
          if (!media) return;
      
          this.el = media;
          this.startScale = 1;
          this.endScale = 1.2;
      
          this.onScroll = this.onScroll.bind(this);
          window.addEventListener('scroll', this.onScroll);
          window.addEventListener('resize', this.onScroll);
          this.onScroll();
        }
      
        onScroll() {
          const rect = this.section.getBoundingClientRect(); 
          const triggerHeight = rect.height * 0.9;
          const p = Math.min(Math.max(rect.top, 0), triggerHeight) / triggerHeight;
          const scale = this.startScale + (this.endScale - this.startScale) * p;
          this.el.style.transform = `scale(${scale})`;
        }
      }
      
      document.querySelectorAll('.image-block__image').forEach(section => {
        new AnimatedHeroImage(section);
      });

});
  

class AnimatedHeroImage_load {
  constructor(img, container) {
    this.img = img;
    this.container = container;
    this.startScale = 1;   // Final scale
    this.endScale = 1.3;   // Initial zoom

    this.onScroll = this.onScroll.bind(this);

    window.addEventListener('scroll', this.onScroll);
    window.addEventListener('resize', this.onScroll);
    this.onScroll();
  }

  onScroll() {
    const containerTop = this.container.getBoundingClientRect().top;

    if (containerTop <= 0) {
      // Section top has reached the top of the viewport
      this.img.style.transform = `scale(${this.startScale})`;
    } else {
      // Before entering — keep zoomed out
      this.img.style.transform = `scale(${this.endScale})`;
    }
  }
}

document.addEventListener('DOMContentLoaded', () => {
  const containers = document.querySelectorAll('.zoom-section');
  containers.forEach(container => {
    const images = container.querySelectorAll('.zoom-img');
    images.forEach(img => {
      new AnimatedHeroImage_load(img, container);
    });
  });
});

  document.addEventListener("mousemove", function () {
    document.body.classList.remove("hide_extra");
  });

  // video optimize 

   document.addEventListener("DOMContentLoaded", function () {
  const lazyVideos = document.querySelectorAll("video.lazy-video");
 
  if ("IntersectionObserver" in window) {
    const videoObserver = new IntersectionObserver((entries, observer) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          const video = entry.target;
 
          const sources = video.querySelectorAll("source[data-src]");
          sources.forEach(source => {
            source.src = source.dataset.src;
            source.removeAttribute("data-src");
          });
 
          video.load();
          // video.play();  
 
          observer.unobserve(video);
        }
      });
    }, { threshold: 0.5 });
 
    lazyVideos.forEach(video => {
      videoObserver.observe(video);
    });
  }
});